import '../../style/App.css';
import { useState, useRef, useEffect } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { backgroundImages } from '../../constants.js';
import FileUpload from '../FileUpload.js';
import TextInput from '../TextInput.js';
import GridMap from '../GridMap.js';

import backgroundButton from "../../pics/icons/backgroundButton.png"
import OptionButton from './OptionButton';
import { useImages } from '../../../../../providers/ImagesProvider';
import ImageDropdown from './ImageDropdown.js';

const ImagePopup = ({setPlayerViewBackground, setDefaultBackgroundOverride, encounterGuid, socket}) => {
    const [open, setOpen] = useState(false);
    const [defaultOverride, setDefaultOverride] = useState(window.localStorage.getItem("defaultBackground") === "true");
    const { backgrounds, setBackgrounds, links, setLinks } = useImages();
    const dialogRef = useRef(null);

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if ((dialogRef.current && !dialogRef.current.contains(event.target)) || event.target.tagName === 'IMG') {
                handleClose();
            }
        };

        if(open) {  
            document.addEventListener('mousedown', handleClickOutside)
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
       
        return () => { document.removeEventListener('mousedown', handleClickOutside); };
    }, [open]);

    const handleSetBackground = (type, src) => {
        setPlayerViewBackground({type: type, src: src})
    }

    const handleClick = (imageObj, isYoutubeLink) => {
        if(imageObj.imageGuid === 'constant') {
            socket.emit("encounterBackgroundChange", imageObj, encounterGuid)
        } else {
            // only send the guid when sending non constant files
            socket.emit("encounterBackgroundChange", {imageGuid: imageObj.imageGuid}, encounterGuid)
        }

        if (isYoutubeLink) { // i.e. https://www.youtube.com/watch?v=H-bd0eyF-HA&ab_channel=AnimatedBattleMaps
            const videoId = imageObj.image.split("vi/")[1].split('/max')[0];
            if (videoId) {
                let embedUrl = "https://www.youtube.com/embed/" + videoId

                const params = {
                    controls: 0,
                    mute: 1,
                    rel: 0,
                    autoplay: 1,
                    loop: 1,
                    playlist: videoId
                }

                // Mute by default and turn off controls so they dont show everytime on hover
                const queryParams = new URLSearchParams(params).toString();
                embedUrl += `?${queryParams}`;
                handleSetBackground("youtube", embedUrl)

            } else {
                console.error('Invalid YouTube URL');
                return;
            }
        } else {
            handleSetBackground("image", imageObj.image)
        }
    };

    const setDefaultBackground = (e) => {
        window.localStorage.setItem("defaultBackground", e.target.checked);
        setDefaultOverride(e.target.checked);
        setDefaultBackgroundOverride(e.target.checked);
    }

    return (
        <>
            <OptionButton src={backgroundButton} message={`Set Background${defaultOverride ? ': Default ON' : ''}`} onClickFunction={() => setOpen(true)} 
                imgStyle={{
                    outline: defaultOverride ? '1px solid rgba(100, 130, 125)' : '',
                    animation: defaultOverride ? 'defaultBackgroundShadowPulse 2.5s ease-in-out infinite' : ''
                }} 
            />
            <Dialog open={open} onClose={handleClose} ref={dialogRef} >

                <div className='avatarUploadHeader'>
                    <hr className='editlineSeperator'/> 
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <FileUpload label={'Background'} storageKey={"background"} setUploadedFiles={setBackgrounds}  hr={false} socket={socket}/>
                        <TextInput label={'Youtube'} setUploadedLinks={setLinks} hr={false} socket={socket}/>
                    </div>
                    <hr />
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                        <i>DmView Background use Default</i>
                        <input type='checkbox' checked={defaultOverride} onChange={setDefaultBackground} 
                            style={{
                                accentColor: '#575757ff',
                                outline: defaultOverride ? '1px solid rgba(100, 130, 125)' : '',
                                animation: defaultOverride ? 'defaultBackgroundShadowPulse 2.5s ease-in-out infinite' : ''
                            }}  
                        />
                    </div>
                    <hr className='lineSeperator' style={{margin: '5px 0 5px 0'}}/>
                </div>
                <DialogContent style={{padding: '5px'}}>
                    <ImageDropdown title='Youtube Links' uploadedType={'link'} autoOpen={true} uploadedFiles={links} setUploadedFiles={setLinks} handleClick={handleClick} socket={socket}/>
                    <ImageDropdown title='Backgrounds' uploadedType={'background'} autoOpen={true} uploadedFiles={backgrounds} setUploadedFiles={setBackgrounds} handleClick={handleClick} socket={socket}/>
                    <hr className='lineSeperator' style={{margin: '10px 0 10px 0'}}/>
                    <label htmlFor="grid" className='uploadedTitle'>Default Backgrounds</label>
                    <hr/>
                    <GridMap imageArr={backgroundImages} handleClick={handleClick}/>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ImagePopup;